import type { GetServerSideProps, NextPage } from "next";
import HomePageV1 from "@/containers/HomePage";
import HomePageV2 from "@/containers/HomePage/V2";
import LoginOTPToggle from "@/components/Toggle/LoginOTPToggle";

const Home: NextPage = () => {
  return (
    <LoginOTPToggle v1Component={<HomePageV1 />} v2Component={<HomePageV2 />} />
  )
};

export default Home;
